// extracted by mini-css-extract-plugin
export default {"anchor":"FlexibleDateBestPriceInner-module__anchor___Wcq1V","card":"FlexibleDateBestPriceInner-module__card___aZbLr"};